import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

function NavigationBar() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#about">About</Nav.Link>
            <Nav.Link href="#education">Education</Nav.Link>
            <Nav.Link href="#skills">Skills </Nav.Link>
            <Nav.Link href="#contacts">Contacts</Nav.Link>
            <Nav.Link
              href="https://john-rey-tolosa.vercel.app/"
              style={{
                borderRadius: "5px",
                border: "1px solid #000",
                padding: "5px 10px",
                backgroundColor: "#f0f0f0",
                color: "#000",
                textDecoration: "none",
              }}
            >
              🎉 Latest Version
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
